// Function to set a value in localStorage
export const setLocalStorage = (key: string, value: any): void => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    // Handle error when localStorage is unavailable or full
    console.error("Error setting localStorage:", error);
  }
};

// Function to get a value from localStorage
export const getLocalStorage = (key: string) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    // Handle error when localStorage is unavailable
    console.error("Error getting localStorage:", error);
    return null;
  }
};
export const deleteLocalStorage = (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    // Handle error when localStorage is unavailable
    console.error("Error deleting from localStorage:", error);
  }
};
